module.exports = __webpack_public_path__ + "static/assets/fd330dc3602855b3a91f1c3c6cd5c865.svg";